export const OPENING_GREETINGS = [
  '你好 (nǐ hǎo)，你好吗 (nǐ hǎo ma)？\nHello, how are you?',
  '你好 (nǐ hǎo)，我很好 (wǒ hěn hǎo)，你好吗 (nǐ hǎo ma)？\nHello, I am fine, how are you?',
  '嗨 (hāi)，你今天怎么样 (nǐ jīntiān zěnmeyàng)？\nHi, how are you today?',
  '早上好 (zǎoshang hǎo)，你好吗 (nǐ hǎo ma)？\nGood morning, how are you?',
  '你好 (nǐ hǎo)，很高兴认识你 (hěn gāoxìng rènshi nǐ)，你好吗 (nǐ hǎo ma)？\nHello, nice to meet you, how are you?',
];
